
// ---------------------------------------------------------------------------
// Extension URLs (Practitioner profile enrichment for intake display)
// ---------------------------------------------------------------------------

export const INTAKE_EXT_URLS = {
  credentials: 'https://unify.health/fhir/credentials',
  shortBio: 'https://unify.health/fhir/short-bio',
  longBio: 'https://unify.health/fhir/long-bio',
  headshotUrl: 'https://unify.health/fhir/headshot-url',
  sessionFormats: 'https://unify.health/fhir/session-formats',
  acceptsInsurance: 'https://unify.health/fhir/accepts-insurance',
  takingNewClients: 'https://unify.health/fhir/taking-new-clients',
  intakeProvider: 'https://unify.health/fhir/intake-provider',
} as const;

// ---------------------------------------------------------------------------
// Questionnaire canonical URLs for intake
// ---------------------------------------------------------------------------

// ---------------------------------------------------------------------------
// Slot / Schedule service type for intake vs consultation
// ---------------------------------------------------------------------------

// ---------------------------------------------------------------------------
// Appointment status mapping
// ---------------------------------------------------------------------------
